import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { RSAnchor } from 'src/reservation-page/RSAnchor';

export interface ConfirmInformationParagraphProps {
  merchantPublicId: string;
  isRequiredForAcceptance: boolean;
}

export const ConfirmInformationParagraph: FC<
  ConfirmInformationParagraphProps
> = ({ merchantPublicId, isRequiredForAcceptance }) => {
  const intl = useIntl();

  if (isRequiredForAcceptance) {
    return (
      <>
        {intl.formatMessage(
          {
            defaultMessage:
              'リクエストが承認され次第、予約が確定します。予約を確定すると、STORES 予約の{termsOfUse}に同意したとみなします。キャンセルその他の販売条件は、{sctl}をあわせてご確認ください。',
            id: 'vhYC1y',
            description:
              'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
          },
          {
            termsOfUse: (
              <RSAnchor
                href="/user_terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  defaultMessage: '利用規約',
                  id: 'VZzJZ4',
                  description:
                    'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
                })}
              </RSAnchor>
            ),
            sctl: (
              <RSAnchor
                href={`/${merchantPublicId}/legal_notice`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  defaultMessage: '特定商取引法に基づく表示',
                  id: 'RvSAyw',
                  description:
                    'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
                })}
              </RSAnchor>
            ),
          },
        )}
      </>
    );
  }

  return (
    <>
      {intl.formatMessage(
        {
          defaultMessage:
            '予約を確定すると、STORES 予約の{termsOfUse}に同意したとみなします。キャンセルその他の販売条件は、{sctl}をあわせてご確認ください。',
          id: 'gdFXi4',
          description:
            'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
        },
        {
          termsOfUse: (
            <RSAnchor
              href="/user_terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({
                defaultMessage: '利用規約',
                id: 'VZzJZ4',
                description:
                  'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
              })}
            </RSAnchor>
          ),
          sctl: (
            <RSAnchor
              href={`/${merchantPublicId}/legal_notice`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({
                defaultMessage: '特定商取引法に基づく表示',
                id: 'RvSAyw',
                description:
                  'src/templates/merchants/resources/book/components/ConfirmInformationParagraph/index.tsx',
              })}
            </RSAnchor>
          ),
        },
      )}
    </>
  );
};
